<template>
    <div class="reactions-like-dislike">
        <div class="reactions-block">
            <div v-bind:class="{'reaction-active': value === 1}" v-on:click='sendReaction(1)'>
                <thumb class="thumb-up-like"></thumb>
                <span>{{ thisLikes || '' }}</span>
            </div>
            <div v-bind:class="{'reaction-active': value === 0}" v-on:click='sendReaction(0)'>
                <thumb class="thumb-up-dislike"></thumb>
                <span>{{ thisDislikes || '' }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import thumb from './Thumb.vue';
    export default {
        components: {
            'thumb': thumb
        },
        props: [
            'likes', 'dislikes', 'value',
            'component_id', 'url'
        ],
        data: function () {
            return {
                loading: false,
                thisLikes: parseInt(this.likes),
                thisDislikes: parseInt(this.dislikes)
            }
        },
        methods: {
            sendReaction: function (value) {
                const thisVm = this;
                if (authorized) {
                    if (this.loading === false) {
                        let oldValue = this.value;
                        this.value   = oldValue === value ? null : value;

                        if (value === 1) {
                            this.thisLikes += this.value === null ? -1 : 1;
                            if (oldValue === 0) {
                                this.thisDislikes--;
                            }
                        } else {
                            this.thisDislikes += this.value === null ? -1 : 1;
                            if (oldValue === 1) {
                                this.thisLikes--;
                            }
                        }
                        this.loading = true;
                        axios.post(this.url, {
                            componentId: this.component_id,
                            value: value
                        })
                        .then(function () {
                            thisVm.loading = false;
                        })
                        .catch(function () {
                            thisVm.loading = false;
                        })
                    }
                } else {
                    document.getElementById('buttonOpenLoginModal').click();
                }
            }
        }
    }
</script>
